import { Delete, Get, Patch } from "./apiHelper";

interface ApiResponse<T> {
  success: boolean;
  message: string;
  data: T;
}

const clientQueueNumbersRoot = "/api/clientQueueNumbers";

// get current queue number
export async function getCurrentClientQueueNumber({
  resourceCentreId,
  serviceProviderId,
  departmentId
}: {
  resourceCentreId: number;
  serviceProviderId: number;
  departmentId: number | null;
}): Promise<ApiResponse<{ queueNumber: number }>> {
  const response = await Get(clientQueueNumbersRoot, true, {
    resourceCentreId,
    serviceProviderId,
    departmentId
  });

  return response.data as ApiResponse<{ queueNumber: number }>;
}

// increment queue number
export async function incrementClientQueueNumber({
  resourceCentreId,
  serviceProviderId,
  departmentId
}: {
  resourceCentreId: number;
  serviceProviderId: number;
  departmentId: number | null;
}): Promise<ApiResponse<null>> {
  const response = await Patch(
    `${clientQueueNumbersRoot}/increment`,
    {
      resourceCentreId,
      serviceProviderId,
      departmentId
    },
    true
  );
  return response.data as ApiResponse<null>;
}

// delete client queue numbers
export async function deleteClientQueueNumbers({
  resourceCentreId
}: {
  resourceCentreId: number;
}): Promise<ApiResponse<null>> {
  const response = await Delete(
    `${clientQueueNumbersRoot}?resourceCentreId=${resourceCentreId}`,
    true
  );
  return response.data as ApiResponse<null>;
}
